const YIN_THRESHOLD = 0.15;

export function detectPitch(buffer: Float32Array, sampleRate: number): number {
  const halfLen = Math.floor(buffer.length / 2);
  const yinBuffer = new Float32Array(halfLen);

  // Step 1: Difference function
  yinBuffer[0] = 1;
  let runningSum = 0;

  for (let tau = 1; tau < halfLen; tau++) {
    let sum = 0;
    for (let i = 0; i < halfLen; i++) {
      const delta = buffer[i] - buffer[i + tau];
      sum += delta * delta;
    }
    yinBuffer[tau] = sum;

    // Step 2: Cumulative mean normalized difference (inline)
    runningSum += yinBuffer[tau];
    yinBuffer[tau] = tau * (yinBuffer[tau] / runningSum);
  }

  // Step 3: Absolute threshold — find first local minimum below threshold
  let tau = 2;
  while (tau < halfLen) {
    if (yinBuffer[tau] < YIN_THRESHOLD) {
      while (tau + 1 < halfLen && yinBuffer[tau + 1] < yinBuffer[tau]) tau++;
      break;
    }
    tau++;
  }

  if (tau === halfLen || yinBuffer[tau] >= YIN_THRESHOLD) return -1;

  // Step 4: Parabolic interpolation
  let betterTau = tau;
  if (tau > 0 && tau < halfLen - 1) {
    const s0 = yinBuffer[tau - 1];
    const s1 = yinBuffer[tau];
    const s2 = yinBuffer[tau + 1];
    betterTau = tau + (s2 - s0) / (2 * (2 * s1 - s2 - s0));
  }

  return sampleRate / betterTau;
}

export function rmsLevel(buffer: Float32Array): number {
  let sum = 0;
  for (let i = 0; i < buffer.length; i++) sum += buffer[i] * buffer[i];
  return Math.sqrt(sum / buffer.length);
}
